// extracted by mini-css-extract-plugin
export default {"subItem":"SubItem_subItem__wD5as","header":"SubItem_header__sn+c1","title":"SubItem_title__IvvFP","description":"SubItem_description__jLiwP"};